import { jsx } from "react/jsx-runtime";
import { Text } from "../../Text/Text.mjs";
const getCharacterLimitStatus = ({ characterLimit, value }) => {
  const inputLength = String(value).length;
  const diff = characterLimit - inputLength;
  const valid = diff >= 0;
  return /* @__PURE__ */ jsx(Text, { size: "small", tone: valid ? "secondary" : "critical", children: `${inputLength}/${characterLimit}` });
};
export {
  getCharacterLimitStatus
};
